module.exports = __webpack_public_path__ + "img/wap_slides_bg_03.1b5b93de.png";